import { ColorSchemeName} from 'react-native';
export interface PropsColorScheme {
  colorScheme: ColorSchemeName,
  setColorScheme: React.Dispatch<React.SetStateAction<ColorSchemeName>>
}


//Light Color
export const colorsLight = {
  Red:    '#FF3B30',
  Orange: '#FF9500',
  Yellow: '#FFCC00',
  Green:  '#34C759',
  Mint:   '#00C7BE',
  Teal:   '#5AC8FA',
  Cyan:   '#32ADE6',
  Blue:   '#007AFF',
  Indigo: '#5856D6',
  Purple: '#AF52DE',
  Pink:   '#FF2D55',
  Brown:  '#A2845E',

  Gray: {
    1: '#8E8E93',
    2: '#AEAEB2',
    3: '#C7C7CC',
    4: '#D1D1D6',
    5: '#E5E5EA',
    6: '#F2F2F7'
  },
  Background: {
    Primary:'#FFFFFF',
    Secondary:'#F2F2F7',
    Tertiary:'#E5E5EA',
    Filled: '#007AFF',
    Tinted: '#007bff28',
    Gray: '#F2F2F7',
    Plain: 'transparent',
    Select: 'transparent',
  },
  Label: {
    Primary:'#000000',
    Secondary:'#3C3C4399',
    Tertiary:'#3C3C434D',
    Quaternary:'#3C3C432E',
    Filled: '#FFFFFF',
    Tinted: '#007AFF',
    Gray: '#000000',
    Plain: '#007AFF',
    Select: '#3C3C434D',
    Selected: '#007AFF',
  },
  Separator:{
    NoTransparency: '#C6C6C8',
    WithTransparency: '#3C3C434A',
  },
  Fill: {
    Primary:'#78788033',
    Secondary:'#78788029',
    Tertiary:'#7676801F',
    Quaternary:'#74748014',
  },
}


//Dark Color
export const colorsDark = {
  Red:    '#FF453A',
  Orange: '#FF9F0A',
  Yellow: '#FFD60A',
  Green:  '#32D74B',
  Mint:   '#66D4CF',
  Teal:   '##40C8E0',
  Cyan:   '#64D2FF',
  Blue:   '#0A84FF',
  Indigo: '#5E5CE6',
  Purple: '#AF52DE',
  Pink:   '#FF2D55',
  Brown:  '#AC8E68',

  Gray: {
    1: '#8E8E93',
    2: '#636366',
    3: '#48484A',
    4: '#3A3A3C',
    5: '#2C2C2E',
    6: '#1C1C1E'
  },
  Background: {
    Primary:'#1C1C1E',
    Secondary:'#2C2C2E',
    Tertiary:'#3A3A3C',
    Filled: '#0A84FF',
    Tinted: '#0A84FF28',
    Gray: '#2C2C2E',
    Plain: 'transparent',
    Select: 'transparent',
    Selected: 'transparent',
  },
  Label: {
    Primary:'#FFFFFF',
    Secondary:'#EBEBF599',
    Tertiary:'#EBEBF54D',
    Quaternary:'#EBEBF52E',
    Filled: '#FFFFFF',
    Tinted: '#0A84FF',
    Gray: '#FFFFFF',
    Plain: '#0A84FF',
    Select: '#EBEBF54D',
    Selected: '#0A84FF',
  },
  Separator:{
    NoTransparency: '#38383A',
    WithTransparency: '#54545899',
  },
  Fill: {
    Primary:'#7878805C',
    Secondary:'#78788052',
    Tertiary:'#7676803D',
    Quaternary:'#7474802E',
  },
}

